const convertObjectToArray = (object) => {
  if (undefined === object || null === object) {
    return [];
  }

  let array: Array<{ id: string; value: unknown }> = [];
  for (const field in object) {
    const filter = {
      id: field,
      value: object[field],
    };
    array.push(filter);
  }

  return array;
};

const removeEmptyFieldsFromObject = (obj) => {
  if (obj) {
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null && v !== ""));
  }
  return obj;
};

export { convertObjectToArray, removeEmptyFieldsFromObject };
